import React from 'react'
import { Helmet } from 'react-helmet-async'
import BackToCaseStudiesHeader from 'src/components/common/BackToCaseStudiesHeader'
import BannerHeader from 'src/components/common/BannerHeader'
import ChallengeApproach from 'src/components/common/ChallengeApproach'
import DataList from 'src/components/common/DataList'
import PlatformFeatures from 'src/components/common/PlatformFeatures'
import TechnologyStack from 'src/components/common/TechnologyStack'
import NotFeelingWell from 'src/views/about/NotFeelingWell'
import { CaseStudyTemplate2Data, CaseStudyMetadata } from 'src/constants/caseStudies/types'

interface Props {
  caseStudyData: CaseStudyTemplate2Data;
  metadata: CaseStudyMetadata;
}

const CaseStudyTemplate2 = (props: Props) => {
    const { caseStudyData, metadata } = props;

    if (!caseStudyData || !metadata) {
        return null;
    }

    const {
        bannerHeader,
        dataListItems,
        challengeApproach,
        platformFeatures,
        technologies,
        securityTitle,
        securityDescription,
    } = caseStudyData;

    const {
        meta: {
            title: metaTitle,
            description: metaDescription,
            canonicalUrl,
            ogImage,
        },
    } = metadata;

    return (
        <div className="flex flex-col">
            <Helmet>
                <title>{metaTitle}</title>
                <meta
                    name="description"
                    content={metaDescription}
                />
                <link rel="canonical" href={canonicalUrl} />
                <meta property="og:type" content="website" />
                <meta property="og:url" content={canonicalUrl} />
                <meta property="og:title" content={metaTitle} />
                <meta
                    property="og:description"
                    content={metaDescription}
                />
                <meta property="og:image" content={ogImage} />
            </Helmet>
            <BackToCaseStudiesHeader />

            <BannerHeader
                pillLabel={bannerHeader.pillLabel}
                title={bannerHeader.title}
                description={bannerHeader.description}
                image={bannerHeader.image}
                images={bannerHeader.images}
                imageAlt={bannerHeader.imageAlt}
                primaryButton={bannerHeader.primaryButton}
                secondaryButton={bannerHeader.secondaryButton}
            />

            <DataList items={dataListItems} />

            <ChallengeApproach
                challengeTitle={challengeApproach.challengeTitle}
                challengeDescription={challengeApproach.challengeDescription}
                requirementsTitle={challengeApproach.requirementsTitle}
                requirements={challengeApproach.requirements}
                approachTitle={challengeApproach.approachTitle}
                approachSections={challengeApproach.approachSections}
                testimonial={challengeApproach.testimonial ? {
                    initials: challengeApproach.testimonial.initials || challengeApproach.testimonial.name.split(' ').map(n => n[0]).join('').toUpperCase().slice(0, 2),
                    name: challengeApproach.testimonial.name,
                    role: challengeApproach.testimonial.role,
                    quote: challengeApproach.testimonial.quote,
                    icon: challengeApproach.testimonial.icon,
                } : undefined}
            />

            <PlatformFeatures
                title="Platform Features"
                features={platformFeatures}
            />

            <TechnologyStack
                title="Technology Stack"
                technologies={technologies}
                securityTitle={securityTitle}
                securityDescription={securityDescription}
                backgroundImage={
                  metadata.slug === 'scholastic-art-writing-awards-portal' 
                    ? 'scholastic-image2.png' 
                    : metadata.slug === 'stylematch'
                    ? 'stylematch/images.png'
                    : undefined
                }
                imagePosition="right"
                imageLayout={metadata.slug === 'stylematch' ? 'row' : 'offset'}
            />

           <NotFeelingWell />
        </div>
    )
}

export default CaseStudyTemplate2

